

import Scroll from "components/shared/scroll";
import React from "react";

import Button from "components/shared/button";
import Checkbox from "components/shared/inputs/checkbox";
import { SvgPlusx, SvgSave, SvgShare } from "components/svg";
import SwitchableCustom from "components/SwitchableCustom";
import { FieldValues, useForm } from "react-hook-form";
import ItemImage1 from "../../styles/images/items/item_1.png";
import ItemImage2 from "../../styles/images/items/item_2.png";
import ItemImage3 from "../../styles/images/items/item_3.png";


const GridLayout: React.FC = () => {


  const { control } = useForm<FieldValues>({
    defaultValues: {
      4: true,
      7: true,
      6: true,
      8: "Option3",
      checkox_option_9: true,
      checkox_option_7: true,
      checkox_option_6: true,
      RadioDemo4: "yes",

      RadioDemo2: "table_View",
      RadioDemo6: "leaf",
    },
  });


  return (
    <view data-vertical=""  >
      <view data-direction="row">
        <SwitchableCustom
          data-pointer
          defaultExpanded={false}
          icon={<Button data-color="grey-color-mid" micro rounded icon="chevron_right" toggleClassName="rotate" />}
          title={"Filtrages avancés"}
          //togglerProps={{ "data-order": "2" }}
          //data-type="overlap"
          //data-size="small"
          //data-container-type="grid"
          //data-elevation="1"
          data-index="3"
        >
          <>
            <group data-space="20" data-gap="10">
              <group><text data-text-size="22">Filtrer votre étude</text></group>
              <group data-type="grid" data-grid-template="240" data-gap="5">
                <group data-gap="5" data-direction="column">
                  <group>
                    <text data-text-size="14" data-color="grey-color-mid">Performance</text>
                  </group>
                  <group data-name="collapsible">
                    <group data-name="collapsible_header" data-interactive="" data-cursor="pointer">
                      <label data-type="group" data-align="center" data-gap="10" data-height="40" data-space-left="10">
                        <text data-weight="500" data-color="grey-color-dark" data-fit="1">Taux de couverture</text>
                        <Button mini rounded toggleClassName="open" data-color="grey-color-mid">
                          <icon>
                            <SvgPlusx />
                          </icon>
                        </Button>
                      </label>
                    </group>
                    <group data-name="collapsible_container">
                      <group data-align="center" data-space-vertical="5" data-gap="3">
                        <group data-name="filter_item" data-interactive="">
                          <Checkbox
                            name="1"
                            label="R32"
                            checkbox
                            control={control}
                          />
                        </group>
                        <group data-name="filter_item" data-interactive="">
                          <Checkbox
                            name="2"
                            label="R290"
                            checkbox
                            control={control}
                          />
                        </group>
                      </group>
                    </group>
                  </group>
                  <group data-name="collapsible">
                    <group data-name="collapsible_header" data-interactive="" data-cursor="pointer">
                      <label data-type="group" data-align="center" data-gap="10" data-height="40" data-space-left="10">
                        <text data-weight="500" data-color="grey-color-dark" data-fit="1">Part PAC à Tbase</text>
                        <Button mini rounded toggleClassName="open" data-color="grey-color-mid">
                          <icon>
                            <SvgPlusx />
                          </icon>
                        </Button>
                      </label>
                    </group>
                    <group data-name="collapsible_container">
                      <group data-align="center" data-space-vertical="5" data-gap="3">
                        <group data-name="filter_item" data-interactive="">
                          <Checkbox
                            name="1"
                            label="R32"
                            checkbox
                            control={control}
                          />
                        </group>
                        <group data-name="filter_item" data-interactive="">
                          <Checkbox
                            name="2"
                            label="R290"
                            checkbox
                            control={control}
                          />
                        </group>
                      </group>
                    </group>
                  </group>
                  <group data-name="collapsible">
                    <group data-name="collapsible_header" data-interactive="" data-cursor="pointer">
                      <label data-type="group" data-align="center" data-gap="10" data-height="40" data-space-left="10">
                        <text data-weight="500" data-color="grey-color-dark" data-fit="1">Objectif</text>
                        <Button mini rounded toggleClassName="open" data-color="grey-color-mid">
                          <icon>
                            <SvgPlusx />
                          </icon>
                        </Button>
                      </label>
                    </group>
                    <group data-name="collapsible_container">
                      <group data-align="center" data-space-vertical="5" data-gap="3">
                        <group data-name="filter_item" data-interactive="">
                          <Checkbox
                            name="1"
                            label="R32"
                            checkbox
                            control={control}
                          />
                        </group>
                        <group data-name="filter_item" data-interactive="">
                          <Checkbox
                            name="2"
                            label="R290"
                            checkbox
                            control={control}
                          />
                        </group>
                      </group>
                    </group>
                  </group>
                  <group data-name="collapsible" className="open">
                    <group data-name="collapsible_header" data-interactive="" data-cursor="pointer">
                      <label data-type="group" data-align="center" data-gap="10" data-height="40" data-space-left="10">
                        <text data-weight="500" data-color="grey-color-dark" data-fit="1">Type de fluide</text>
                        <Button mini rounded toggleClassName="open" data-color="grey-color-mid">
                          <icon>
                            <SvgPlusx />
                          </icon>
                        </Button>
                      </label>
                    </group>
                    <group data-name="collapsible_container">
                      <group data-align="center" data-space-vertical="5" data-gap="3">
                        <group data-name="filter_item" data-interactive="">
                          <Checkbox
                            name="3"
                            label="R32"
                            checkbox
                            control={control}
                          />
                        </group>
                        <group data-name="filter_item" data-interactive="" className="checked">
                          <Checkbox
                            name="4"
                            label="R290"
                            checkbox
                            control={control}
                          />
                        </group>
                      </group>
                    </group>
                  </group>
                  <separator data-horizontal="" data-margin='none'></separator>
                </group>

                <group data-gap="5" data-direction="column">
                  <group>
                    <text data-text-size="14" data-color="grey-color-mid">Pompe à chaleur</text>
                  </group>
                  <group data-name="collapsible">
                    <group data-name="collapsible_header" data-interactive="" data-cursor="pointer">
                      <label data-type="group" data-align="center" data-gap="10" data-height="40" data-space-left="10">
                        <text data-weight="500" data-color="grey-color-dark" data-fit="1">Type de fluide</text>
                        <Button mini rounded toggleClassName="open" data-color="grey-color-mid">
                          <icon>
                            <SvgPlusx />
                          </icon>
                        </Button>
                      </label>
                    </group>
                    <group data-name="collapsible_container">
                      <group data-align="center" data-space-vertical="5" data-gap="3">
                        <group data-name="filter_item" data-interactive="">
                          <Checkbox
                            name="1"
                            label="R32"
                            checkbox
                            control={control}
                          />
                        </group>
                        <group data-name="filter_item" data-interactive="">
                          <Checkbox
                            name="2"
                            label="R290"
                            checkbox
                            control={control}
                          />
                        </group>
                      </group>
                    </group>
                  </group>
                  <group data-name="collapsible">
                    <group data-name="collapsible_header" data-interactive="" data-cursor="pointer">
                      <label data-type="group" data-align="center" data-gap="10" data-height="40" data-space-left="10">
                        <text data-weight="500" data-color="grey-color-dark" data-fit="1">Type de fluide</text>
                        <Button mini rounded toggleClassName="open" data-color="grey-color-mid">
                          <icon>
                            <SvgPlusx />
                          </icon>
                        </Button>
                      </label>
                    </group>
                    <group data-name="collapsible_container">
                      <group data-align="center" data-space-vertical="5" data-gap="3">
                        <group data-name="filter_item" data-interactive="">
                          <Checkbox
                            name="1"
                            label="R32"
                            checkbox
                            control={control}
                          />
                        </group>
                        <group data-name="filter_item" data-interactive="">
                          <Checkbox
                            name="2"
                            label="R290"
                            checkbox
                            control={control}
                          />
                        </group>
                      </group>
                    </group>
                  </group>
                  <group data-name="collapsible">
                    <group data-name="collapsible_header" data-interactive="" data-cursor="pointer">
                      <label data-type="group" data-align="center" data-gap="10" data-height="40" data-space-left="10">
                        <text data-weight="500" data-color="grey-color-dark" data-fit="1">Type de fluide</text>
                        <Button mini rounded toggleClassName="open" data-color="grey-color-mid">
                          <icon>
                            <SvgPlusx />
                          </icon>
                        </Button>
                      </label>
                    </group>
                    <group data-name="collapsible_container">
                      <group data-align="center" data-space-vertical="5" data-gap="3">
                        <group data-name="filter_item" data-interactive="">
                          <Checkbox
                            name="1"
                            label="R32"
                            checkbox
                            control={control}
                          />
                        </group>
                        <group data-name="filter_item" data-interactive="">
                          <Checkbox
                            name="2"
                            label="R290"
                            checkbox
                            control={control}
                          />
                        </group>
                      </group>
                    </group>
                  </group>
                  <group data-name="collapsible" className="open">
                    <group data-name="collapsible_header" data-interactive="" data-cursor="pointer">
                      <label data-type="group" data-align="center" data-gap="10" data-height="40" data-space-left="10">
                        <text data-weight="500" data-color="grey-color-dark" data-fit="1">Type de fluide</text>
                        <Button mini rounded toggleClassName="open">
                          <icon>
                            <SvgPlusx />
                          </icon>
                        </Button>
                      </label>
                    </group>
                    <group data-name="collapsible_container">
                      <group data-align="center" data-space-vertical="5" data-gap="3">
                        <group data-name="filter_item" data-interactive="">
                          <Checkbox
                            name="3"
                            label="R32"
                            checkbox
                            control={control}
                          />
                        </group>
                        <group data-name="filter_item" data-interactive="" className="checked">
                          <Checkbox
                            name="4"
                            label="R290"
                            checkbox
                            control={control}
                          />
                        </group>
                      </group>
                    </group>
                  </group>
                  <separator data-horizontal="" data-margin='none'></separator>
                </group>
              </group>
            </group>

          </>
        </SwitchableCustom>

        <view data-name="switchable" data-direction="column" data-align="start">
          <view data-scroll="" data-container-type="grid">
            <group
              data-align="center"
              data-gap="5"
              data-elevation="1"
              data-index="2"
              data-backdrop=""
              data-wrap="no"
              data-sticky="top"

            >

              <group data-wrap="no" data-direction="column" data-space="10" data-space-left="30">
                <text data-text-size="22">Nos solutions</text>
                <text>
                  Prix incluant la PAC et ses accessoires ainsi que la production d'ECS si elle fait partie du périmètre (hors générateur chaudière pour les solutions hybrides)
                </text>
              </group>

            </group>


            <group
              data-scroll-mask="false"
              //data-scroll-type="snap"
              data-scroll-padding="20"
            >
              <Scroll>
                <group data-width="auto">
                  <group data-width="auto">
                    <group data-space="30" data-wrap="no" data-direction="column" data-width="auto" data-gap="1">
                      <group data-wrap="no" data-width="auto">
                        <group data-length="380" data-background="main-background" data-border="" data-sticky="left" ></group>
                        <div className="item custom" data-border="" data-length="260">
                          <group data-direction="column" data-align="center" data-gap="10" data-space="20" data-space-top="0">
                            <group data-name="title" data-length="180" data-height="40" data-align="center" data-justify="center" data-gap="5" data-background="accent-xtralight" data-radius-bottom="10"><text data-uppercase="" data-weight="600">Nom de proposition 1</text></group>
                            {/*<group data-radius="3" data-background="main" toggleClassName="open" data-color="white" data-height="40" data-align="center" data-justify="center" data-gap="5" ><icon>check</icon><text data-width="auto">Sélectionner cette proposition</text></group>*/}

                            <Button
                              //data-radius="3"
                              //data-background="main"
                              //data-color="white"
                              data-height="40"
                              //data-align="center"
                              //data-justify="center"
                              //data-gap="5"
                              toggleClassName="open"
                              data-name="custom_button"
                            >
                              <icon>check</icon>
                              <text>Sélectionner cette proposition</text>
                            </Button>

                            <group><div className="button fit accent" data-radius="3" data-height="40"><group data-align="center" data-justify="center" data-gap="5"><icon>visibility</icon><text data-width="auto">Détail de la solution</text></group></div></group>
                            <group data-space-vertical="20" data-justify="center">
                              <group data-ratio="5:4" data-shrink="no" data-contain="" data-length="140"><picture><img src={ItemImage1} alt="" /></picture></group>
                            </group>
                            <group data-name="cost" data-align="center" data-justify="center"><text data-text-size="22">1234€</text></group>
                          </group>
                        </div>
                        <div className="item custom" data-border="" data-length="260">
                          <group data-direction="column" data-align="center" data-gap="10" data-space="20" data-space-top="0">
                            <group data-name="title" data-length="180" data-height="40" data-align="center" data-justify="center" data-gap="5" data-background="accent-xtralight" data-radius-bottom="10"><text data-uppercase="" data-weight="600">Nom de proposition 1</text></group>
                            <group data-radius="3" data-background="main" data-color="white" data-height="40" data-align="center" data-justify="center" data-gap="5"><icon>check</icon><text data-width="auto">Sélectionner cette proposition</text></group>
                            <group><div className="button fit accent" data-radius="3" data-height="40"><group data-align="center" data-justify="center" data-gap="5"><icon>visibility</icon><text data-width="auto">Détail de la solution</text></group></div></group>
                            <group data-space-vertical="20" data-justify="center">
                              <group data-ratio="5:4" data-shrink="no" data-contain="" data-length="140"><picture><img src={ItemImage2} alt="" /></picture></group>
                            </group>
                            <group data-name="cost" data-align="center" data-justify="center"><text data-text-size="22">1234€</text></group>
                          </group>
                        </div>
                        <div className="item custom" data-border="" data-length="260">
                          <group data-direction="column" data-align="center" data-gap="10" data-space="20" data-space-top="0">
                            <group data-name="title" data-length="180" data-height="40" data-align="center" data-justify="center" data-gap="5" data-background="accent-xtralight" data-radius-bottom="10"><text data-uppercase="" data-weight="600">Nom de proposition 1</text></group>
                            <group data-radius="3" data-background="main" data-color="white" data-height="40" data-align="center" data-justify="center" data-gap="5"><icon>check</icon><text data-width="auto">Sélectionner cette proposition</text></group>
                            <group><div className="button fit accent" data-radius="3" data-height="40"><group data-align="center" data-justify="center" data-gap="5"><icon>visibility</icon><text data-width="auto">Détail de la solution</text></group></div></group>
                            <group data-space-vertical="20" data-justify="center">
                              <group data-ratio="5:4" data-shrink="no" data-contain="" data-length="140"><picture><img src={ItemImage3} alt="" /></picture></group>
                            </group>
                            <group data-name="cost" data-align="center" data-justify="center"><text data-text-size="22">1234€</text></group>
                          </group>
                        </div>
                      </group>

                      <group data-width="auto" data-wrap="no" data-direction="column" data-name="grid_row">
                        <group data-name="grid_header" data-border>
                          <group data-wrap="no">
                            <group data-length="380" data-align="center" data-gap="10" data-space-left="10" data-background="grey-color-light" data-border-left="" data-border-vertical="1" data-sticky="left">
                              <Button data-color="grey-color-mid" micro rounded icon="expand_more" toggleClassName="rotate" />
                              <text data-weight="500" data-color="grey-color-mid">Information générales</text>
                            </group>
                            <group data-border-vertical="1" data-background="grey-color-light" data-length="260" data-height="40" data-space-horizontal="10" data-align="center"></group>
                            <group data-border-vertical="1" data-background="grey-color-light" data-length="260" data-height="40" data-space-horizontal="10" data-align="center"></group>
                            <group data-border-vertical="1" data-background="grey-color-light" data-length="260" data-height="40" data-space-horizontal="10" data-align="center"></group>
                          </group>
                        </group>
                        <group data-name="grid_container" data-width="auto" data-direction="column">
                          <group data-wrap="no" data-sticky-row="" data-name="heading_row">
                            <group data-width="auto" data-flex="no" data-sticky="left">
                              <group data-length="40" data-shrink="0" data-height="fit" data-align="center" data-justify="center" data-color="white" data-background="main">
                                <text data-orientation="vertical-invert">Title</text>
                              </group>
                              <group data-direction="column" data-width="auto">
                                <group data-background="accent-xtralight" data-sticky="left" data-length="340" data-height="40" data-border="inset" data-space-horizontal="20" data-align="center" data-direction="row">
                                  <text data-position="left" data-weight="500">PAC</text>
                                </group>
                                <group data-background="accent-xtralight" data-sticky="left" data-length="340" data-height="40" data-border="inset" data-space-horizontal="20" data-align="center" data-direction="row">
                                  <text data-position="left" data-weight="500">Appoint électrique total</text>
                                  <div data-type="group" data-width="auto" data-space="5" data-interactive="" data-radius="30" data-color="grey-color-mid"><icon data-icon-size="small">help</icon></div>
                                </group>
                                <group data-background="accent-xtralight" data-sticky="left" data-length="340" data-height="40" data-border="inset" data-space-horizontal="20" data-align="center" data-direction="row">
                                  <text data-position="left" data-weight="500">Appoint électrique total</text>
                                  <div data-type="group" data-width="auto" data-space="5" data-interactive="" data-radius="30" data-color="grey-color-mid"><icon data-icon-size="small">help</icon></div>
                                </group>
                              </group>
                            </group>
                            <group data-direction="column" data-width="auto">
                              <group data-wrap="no" data-width="auto">
                                <group data-length="260" data-height="40" data-border="inset" data-space-horizontal="10" data-align="center">
                                  <text data-position="center" data-weight="500">1 Effipac 50</text>
                                </group>
                                <group data-length="260" data-height="40" data-border="inset" data-space-horizontal="10" data-align="center">
                                  <text data-position="center" data-weight="500">2 effipac 18</text>
                                </group>
                                <group data-length="260" data-height="40" data-border="inset" data-space-horizontal="10" data-align="center">
                                  <text data-position="center" data-weight="500">1 Effipac 50</text>
                                </group>
                              </group>

                              <group data-wrap="no" data-width="auto">
                                <group data-length="260" data-height="40" data-border="inset" data-space-horizontal="10" data-align="center">
                                  <text data-position="center" data-weight="500">1 Effipac 50</text>
                                </group>
                                <group data-length="260" data-height="40" data-border="inset" data-space-horizontal="10" data-align="center">
                                  <text data-position="center" data-weight="500">2 effipac 18</text>
                                </group>
                                <group data-length="260" data-height="40" data-border="inset" data-space-horizontal="10" data-align="center">
                                  <text data-position="center" data-weight="500">1 Effipac 50</text>
                                </group>
                              </group>

                              <group data-wrap="no" data-width="auto">
                                <group data-length="260" data-height="40" data-border="inset" data-space-horizontal="10" data-align="center">
                                  <text data-position="center" data-weight="500">1 Effipac 50</text>
                                </group>
                                <group data-length="260" data-height="40" data-border="inset" data-space-horizontal="10" data-align="center">
                                  <text data-position="center" data-weight="500">2 effipac 18</text>
                                </group>
                                <group data-length="260" data-height="40" data-border="inset" data-space-horizontal="10" data-align="center">
                                  <text data-position="center" data-weight="500">1 Effipac 50</text>
                                </group>
                              </group>
                            </group>

                          </group>



                          <group data-wrap="no" data-width="auto">
                            <group data-background="main-background" data-sticky="left" data-length="380" data-height="40" data-border="inset" data-space-horizontal="20" data-align="center" data-direction="row">
                              <text data-position="left" data-weight="500">Appoint électrique total</text>
                              <div data-type="group" data-width="auto" data-space="5" data-interactive="" data-radius="30" data-color="grey-color-mid"><icon data-icon-size="small">help</icon></div>
                            </group>
                            <group data-length="260" data-height="40" data-border="inset" data-space-horizontal="10" data-align="center">
                              <text data-position="left" data-color="grey-color-dark" data-weight="400">6 kW</text>
                            </group>
                            <group data-length="260" data-height="40" data-border="inset" data-space-horizontal="10" data-align="center">
                              <text data-position="left" data-color="grey-color-dark" data-weight="400">21 kW</text>
                            </group>
                            <group data-length="260" data-height="40" data-border="inset" data-space-horizontal="10" data-align="center">
                              <text data-position="left" data-color="grey-color-dark" data-weight="400">6 kW</text>
                            </group>
                          </group>
                          <group data-wrap="no" data-width="auto">
                            <group data-background="main-background" data-sticky="left" data-length="380" data-height="40" data-border="inset" data-space-horizontal="20" data-align="center" data-direction="row">
                              <text data-position="left" data-weight="500">Appoint électrique total</text>
                              <div data-type="group" data-width="auto" data-space="5" data-interactive="" data-radius="30" data-color="grey-color-mid"><icon data-icon-size="small">help</icon></div>
                            </group>
                            <group data-length="260" data-height="40" data-border="inset" data-space-horizontal="10" data-align="center">
                              <text data-position="left" data-color="grey-color-dark" data-weight="400">6 kW</text>
                            </group>
                            <group data-length="260" data-height="40" data-border="inset" data-space-horizontal="10" data-align="center">
                              <text data-position="left" data-color="grey-color-dark" data-weight="400">21 kW</text>
                            </group>
                            <group data-length="260" data-height="40" data-border="inset" data-space-horizontal="10" data-align="center">
                              <text data-position="left" data-color="grey-color-dark" data-weight="400">6 kW</text>
                            </group>
                          </group>
                          <group data-wrap="no" data-width="auto">
                            <group data-background="main-background" data-sticky="left" data-length="380" data-height="40" data-border="inset" data-space-horizontal="20" data-align="center" data-direction="row">
                              <text data-position="left" data-weight="500">Appoint électrique total</text>
                              <div data-type="group" data-width="auto" data-space="5" data-interactive="" data-radius="30" data-color="grey-color-mid"><icon data-icon-size="small">help</icon></div>
                            </group>
                            <group data-length="260" data-height="40" data-border="inset" data-space-horizontal="10" data-align="center">
                              <text data-position="left" data-color="grey-color-dark" data-weight="400">6 kW</text>
                            </group>
                            <group data-length="260" data-height="40" data-border="inset" data-space-horizontal="10" data-align="center">
                              <text data-position="left" data-color="grey-color-dark" data-weight="400">21 kW</text>
                            </group>
                            <group data-length="260" data-height="40" data-border="inset" data-space-horizontal="10" data-align="center">
                              <text data-position="left" data-color="grey-color-dark" data-weight="400">6 kW</text>
                            </group>
                          </group>
                        </group>
                      </group>

                      <group data-width="auto" data-wrap="no" >
                        <group data-length="380"
                        //data-background="red"
                        >
                        </group>
                        <div className="item custom" data-border="" data-length="260">
                          <group data-direction="column" data-align="center" data-gap="10" data-space="20">
                            <group>
                              <group data-justify="center" data-length="autofit">
                                <group data-ratio="5:4" data-shrink="no" data-contain="" data-length="50"><picture><img src={ItemImage1} alt="" /></picture></group>
                              </group>
                              <group data-direction="column" data-length="autofit" data-justify="center">
                                <group data-name="cost" data-align="center" ><text data-text-size="medium">1234€</text></group>
                                <group data-gap="5" data-radius-bottom="10"><text data-decoration="underline" data-weight="400" data-color="grey-color-mid" data-text-size="14">Nom de proposition 1</text></group>
                              </group>
                            </group>
                            <group data-radius="3" data-background="main" data-color="white" data-height="40" data-align="center" data-justify="center" data-gap="5"><icon>check</icon><text data-width="auto">Sélectionner cette proposition</text></group>
                          </group>
                        </div>
                        <div className="item custom" data-border="" data-length="260">
                          <group data-direction="column" data-align="center" data-gap="10" data-space="20">
                            <group>
                              <group data-justify="center" data-length="autofit">
                                <group data-ratio="5:4" data-shrink="no" data-contain="" data-length="50"><picture><img src={ItemImage2} alt="" /></picture></group>
                              </group>
                              <group data-direction="column" data-length="autofit" data-justify="center">
                                <group data-name="cost" data-align="center" ><text data-text-size="medium">1234€</text></group>
                                <group data-gap="5" data-radius-bottom="10" data-decoration="underline"><text data-link="" data-color="grey-color-mid" data-text-size="14">Nom de proposition 1</text></group>
                              </group>
                            </group>
                            <group data-radius="3" data-background="main" data-color="white" data-height="40" data-align="center" data-justify="center" data-gap="5"><icon>check</icon><text data-width="auto">Sélectionner cette proposition</text></group>
                          </group>
                        </div>
                        <div className="item custom" data-border="" data-length="260">
                          <group data-direction="column" data-align="center" data-gap="10" data-space="20">
                            <group>
                              <group data-justify="center" data-length="autofit">
                                <group data-ratio="5:4" data-shrink="no" data-contain="" data-length="50"><picture><img src={ItemImage3} alt="" /></picture></group>
                              </group>
                              <group data-direction="column" data-length="autofit" data-justify="center">
                                <group data-name="cost" data-align="center" ><text data-text-size="medium">1234€</text></group>
                                <group data-gap="5" data-radius-bottom="10" data-decoration="underline"><text data-link="" data-color="grey-color-mid" data-text-size="14">Nom de proposition 1</text></group>
                              </group>
                            </group>
                            <group data-radius="3" data-background="main" data-color="white" data-height="40" data-align="center" data-justify="center" data-gap="5"><icon>check</icon><text data-width="auto">Sélectionner cette proposition</text></group>
                          </group>
                        </div>

                      </group>

                    </group>
                  </group>
                </group>

              </Scroll>
            </group>

            <group data-sticky="bottom" data-align="center" data-gap="5" data-index="2" data-wrap="no" data-disabled="" >
              <group data-gap="10" data-position="right" data-width="auto" data-space='1' data-space-left='20' data-border="" data-background="main-background" data-disabled="off" data-name="command-bar">
                <group data-gap="10" data-border="" data-background="main-background" data-space="20">
                  <Button primary large text="Sauvegarder">
                    <icon data-svg-size="16" >
                      <SvgSave />
                    </icon>
                  </Button>
                  <Button accent large>
                    <icon data-svg-size="24" data-svg-color="main">
                      <SvgShare />
                    </icon>
                  </Button>
                </group>

              </group>
            </group>
          </view>
        </view>
      </view>
    </view>
  );
};
export default GridLayout;
